import messages from 'app/checkout/components/CheckoutLayout/components/FulfillmentInfoWithOptions/FulfillmentInfoWithOptions.messages';
import { DecoratedField, OptionalField } from 'app/common/components';
import classNames from 'classnames';
import React from 'react';
import { useFormatMessage } from 'app/common/hooks';

const PurchaseOrderNumber = ({ active, isSubmitting, required = false }) => {
  const formatMessage = useFormatMessage();
  const disabled = isSubmitting || !active;
  const field = (
    <DecoratedField
      disabled={disabled}
      id="purchaseOrderNumber"
      name="purchaseOrderNumber"
      placeholder={formatMessage(messages.purchaseOrderNumberLabel)}
      maxLength={20}
      required={required}
      hint={formatMessage(messages.purchaseOrderNumberHint)}
    />
  );
  return (
    <div className="flex flex-col" style={{ paddingBottom: 15 }}>
      <fieldset
        className="flex flex-col items-start justify-start"
        disabled={disabled}
      >
        <legend className="flex mb-4 text-gray-900 font-bold lg:text-lg">
          <span>{formatMessage(messages.purchaseOrderNumberLabel)}</span>
          {required && (
            <span
              aria-hidden="true"
              className={classNames('ml-1', {
                'text-red-500': !disabled,
                'text-red-300': disabled
              })}
            >
              {'*'}
            </span>
          )}
        </legend>
        {required ? (
          field
        ) : (
          <OptionalField
            name="purchaseOrderNumber"
            triggerLabel={formatMessage(messages.purchaseOrderNumberAdd)}
          >
            {field}
          </OptionalField>
        )}
      </fieldset>
    </div>
  );
};

export default PurchaseOrderNumber;
